module.exports = __webpack_public_path__ + "static/media/client-3.088c11a8.jpg";